import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PageLoading, StateArea } from '../../../core-components/theme/components/Screen';
import { useEditBatchConfiguration } from '../hooks/useEditBatchConfiguration';
import BatchConfigurationForm from './BatchConfigurationForm';
import { PreFormBatchConfiguration } from '../types/BatchConfigType';

interface EditBatchConfigurationFormProps {
  batchConfigurationId: string;
  preFormBatchConfiguration?: PreFormBatchConfiguration;
  assetId: string;
}

export default function EditBatchConfigurationForm({
  batchConfigurationId,
  preFormBatchConfiguration,
  assetId,
}: EditBatchConfigurationFormProps) {
  const { t } = useTranslation();
  const { batchConfigurationDetails, isLoadingFormDetails, batchConfigurationDetailsError } =
    useEditBatchConfiguration(batchConfigurationId);

  if (isLoadingFormDetails) return <PageLoading />;

  if (batchConfigurationDetailsError)
    return (
      <StateArea>
        <Alert severity="error" sx={{ alignSelf: 'stretch' }}>
          {t('batchConfig.loadError', 'Error loading batch configuration details:')} {batchConfigurationDetailsError.message}
        </Alert>
      </StateArea>
    );

  if (!batchConfigurationDetails)
    return (
      <StateArea>
        <Alert severity="warning" sx={{ alignSelf: 'stretch' }}>
          {t('batchConfig.noDetails', 'No batch configuration details found.')}
        </Alert>
      </StateArea>
    );
  return (
    <BatchConfigurationForm
      key={JSON.stringify(batchConfigurationDetails)}
      initialFormData={batchConfigurationDetails}
      preFormBatchConfiguration={preFormBatchConfiguration}
      assetId={assetId}
    />
  );
}
